import React, { useEffect, useState } from "react";
import { Pause, Play } from "lucide-react";

const KEY = "larus:sidebar-texture-paused";

/* Restrained monochrome grain + slow tonal drift behind the black navigation. CSS only, clipped to the sidebar, pausable, honours prefers-reduced-motion. */
export function SidebarTexture() {
  const [paused, setPaused] = useState(() => localStorage.getItem(KEY) === "1");
  useEffect(() => { localStorage.setItem(KEY, paused ? "1" : "0"); document.documentElement.dataset.sbTexture = paused ? "paused" : "live"; }, [paused]);
  return (<>
    <div className="sb-texture" aria-hidden data-testid="sidebar-texture" data-paused={paused ? "true" : "false"} />
    <button className="ghost sb-texture-toggle" onClick={() => setPaused(!paused)} aria-pressed={paused} aria-label={paused ? "Resume sidebar texture motion" : "Pause sidebar texture motion"} title={paused ? "Resume motion" : "Pause motion"} data-testid="texture-toggle">{paused ? <Play size={12} aria-hidden /> : <Pause size={12} aria-hidden />}</button>
  </>);
}
